import WideViewModal from "components/__new/common/WideViewModal";
import { Input } from "components/__new/common/form";
import { ButtonLoader } from "components/__new/common/form";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import {transformArrayIdsAndNames} from "utils/transformData";
import * as groupsActions from "store/entities/groups/action";
import { ReactComponent as AddIcon } from "assets/images/icons/add-01.svg";
import { ReactComponent as CancelIcon } from "assets/images/icons/cancel.svg";
import { ReactComponent as CloseIcon } from "assets/images/icons/close-dark.svg";
import ModalAlert from 'components/__new/common/ModalAlert';
import { createPayGroup } from "store/entities/payroll/payrollSetup/action";

import {Chips, DropDownSearch} from "components/__new/groups/sub-components"
import validate from "utils/validate";

const AddGroupModal = (props) => {
  const dispatch = useDispatch()
  const arr = transformArrayIdsAndNames(props?.data)
  
  
  
    const {assignToGroupParams, setIsAddGroupOpen, isAddGroupOpen, data, getGroups} = props;
    
    // const { createGroupSuccess  } = useSelector((s) => s.entities.groups);
    const { createdPayGroup, createPayGroupLoading } = useSelector((s) => s.entities.payrollSetup);
    const [display, setDisplay] = useState(false)
    const [isGroupCreated, setIsGroupCreated] = useState(false)
    const [checkedItems, setCheckedItems] = useState({});
    const [isOpenModalAlertSuccess, setIsOpenModalAlertSuccess] = useState(false)
    
    

    
    
  
    const [form, setForm] = useState({
      name: "",
  })
  
    const submitForm = (e) => {
        e.preventDefault();
        
        const errors = validate(form);
        
        if (errors){
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            const payload = {
                name: form.name,
                employee_ids: checkedIds,
            }
            // dispatch(groupsActions.createGroupB2b(payload)).then(() => getGroups());
            // setIsGroupCreated(true)
            dispatch(createPayGroup(payload)).then(() => getGroups());
            setIsGroupCreated(true)
        }
        
    }
  
    // useEffect(() => {
    //     setParams(assignToGroupParams);
    // }, [assignToGroupParams])
  
  
    // useEffect(() => {
    //     if (assignEmployeeToGroupSuccess === true){
    //         setParams({...params, isOpen: false});
    //         props.reloadData();
    //     }
    //     // eslint-disable-next-line
    // }, [assignEmployeeToGroupSuccess])
    
    const services = [
      {
        id: 1,
        name: "On-Demand Pay - 50%"
      },
      {
        id: 2,
        name: "Payroll - Benefits in kind"
      },
      {
        id: 3,
        name: "Payroll - Pay Structure"
      },
    ]
    
    
    const checkedIds = Object?.entries(checkedItems)
  ?.filter(([id, value]) => value === true)
  ?.map(([id]) => id);

    // Create the checkedList array
    const checkedList = checkedIds?.map(id => {
      const item = arr?.find(item => item.id === id);
      return { id: item.id, name: item.name };
    });
    
    const handleRemoveChip = (id) => {
      setCheckedItems(prevState => ({
        ...prevState,
        [id]: false
      }));
    };
    
    
    useEffect(() => {
      if(isGroupCreated && createdPayGroup?.id){
        setIsAddGroupOpen(false)
        setIsGroupCreated(false);
        setCheckedItems({})
        setForm({
          name: ""
        })
        // setIsOpenModalAlertSuccess(true)
      }
      // eslint-disable-next-line
  }, [createdPayGroup]);
    
  
    
    return (
      <WideViewModal isOpen={isAddGroupOpen}  wideViewControl={true} size={"xs"} wideViewClassName="w-[40%]" setIsOpen={() => setIsAddGroupOpen(false)}>
        <div className="w-full h-full p-[22px]">
          <ModalAlert
              successText="Group created successfully!"
              dismissText="Close"
              isOpenModalAlert={isOpenModalAlertSuccess}
              setIsOpenModalAlert={setIsOpenModalAlertSuccess}
          />
          <div className="flex justify-between items-center mb-[24px]">
            <div className="font-aeonik text-2xl font-bold leading-7 text-left flex justify-between">
                <div>Add Group</div>
            </div> 
            <button type="button" onClick={() => setIsAddGroupOpen(false)} className="w-[26px] h-[26px] bg-[#F4F4F4] flex items-center justify-center">
              <CloseIcon  className='cursor-pointer text-[#4E4E4E]' />
            </button> 
          </div>
          <form onSubmit={submitForm}>
          <div className="mb-[2rem]">
            <Input type="text" label="Group Name" placeholder="Enter Group Name" required={true} name="name" value={form.name} onChange={(e) => setForm({name: e.target.value})} inputClass="capitalize" />
        </div>
        {Boolean(checkedItems) && <div className="max-h-[185px] p-2 border-[0.5px] border-[#E5E7EB] rounded-[8px] inline-flex flex-wrap gap-2">
          {checkedList?.map(({id, name}) => (
            <Chips 
              key={id} 
              text={name}
              icon={<CancelIcon className="w-4 h-4" />}
              handleClick={() => handleRemoveChip(id)} 
            />
          ))}
        </div>}
      <div className="mt-4 flex">
        {/* <ButtonLoader type="button" loading={getAllGroupsLoading} className="border btn w-full"> */}
        <button type="button" onClick={() => setDisplay(!display)} className="flex items-center gap-2 text-[#00535C] border btn w-full"><span className=''></span>{<AddIcon />}<span className=''>Add Employees to Group</span></button>
            <DropDownSearch 
              titleIcon={<AddIcon />} 
              arr={arr ?? arr} 
              title="Add Employees to Group" 
              triggerClass="flex items-center gap-2 text-[#00535C]" 
              listClass="flex gap-2 item-center p-2 cursor-pointer" 
              isOpen={display}
              setIsOpen={setDisplay}
              checkedItems={checkedItems}
              setCheckedItems={setCheckedItems}
            />
            
        {/* </ButtonLoader> */}
      </div>
      {/* <div className="h-[100px]">
        <div className="bg-[#FFFFFF] overflow-auto flex rounded-lg py-4 mt-4 sm:flex-wrap sm:gap-x-6">
          {
            services?.map((service, index) => {
              return (
            <div key={index} className="flex text-xs justify-between items-center border-2 p-2 m-2 text-center rounded-full bg-[#F9F5FF] text-[#6941C6]">
              {service.name}
            </div>
              )
            })
          }
        </div>
      </div> */}
        
        <div className="mt-4 flex justify-end space-x-4">
          <button type="button" onClick={() => setIsAddGroupOpen((prevState => !prevState))} className="btn btn-transparent-primary">
              Cancel
          </button>
          <ButtonLoader type="submit" loading={createPayGroupLoading} className="btn btn-ep-primary">
              {createPayGroupLoading ? "Creating group..." : "Create Group"}
          </ButtonLoader>
        </div>
          </form>
        </div>
      </WideViewModal>
    )
   }
   
export default AddGroupModal;
